export default "__VITE_ASSET__BIrz8CYM__"